import React from "react"
import { useTranslation } from "react-i18next"

import { APIStatus } from "shared/ui/api-status/APIStatus"

interface FavoritesAPIStatusProps {
  isUnavailable: boolean
}

export const FavoritesAPIStatus = React.memo(
  ({ isUnavailable }: FavoritesAPIStatusProps) => {
    const { t } = useTranslation()
    return (
      <APIStatus
        isUnavailable={isUnavailable}
        unavailableMessage={t("Favorites.ServiceUnavailable")}
        className="favorites"
      />
    )
  }
)
